<mat-radio-group
  class="radio-group"
  [ngClass]="{ 'radio-group--inline': templateOptions.inline, 'radio-group--stacked': !templateOptions.inline }"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [tabindex]="templateOptions.tabindex || 0"
>
  <mat-radio-button
    *ngFor="let option of templateOptions.options | formlySelectOptions:field | async; trackBy: trackOption; let i = index;"
    [id]="id + '_' + i"
    [color]="templateOptions.color"
    [labelPosition]="templateOptions.labelPosition"
    [value]="option.value"
    (change)="onChange(i)"
  >
    {{ option.label }}
  </mat-radio-button>
</mat-radio-group>
